import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';
import { selectedScheduleFacilityIdSelector } from 'store/selectors/scheduleSelectors/selectedScheduleFacilityIdSelector';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isLineSchedulingFeatureEnabledSelector = createSelector(
  getUserPermissions,
  selectedScheduleFacilityIdSelector,
  (userPermissions, communityId) => {
    if (userPermissions?.SCHEDULING_BY_LINE?.access)
      return (
        userPermissions.SCHEDULING_BY_LINE.access.includes('read') &&
        !!userPermissions.SCHEDULING_BY_LINE.communities &&
        !!userPermissions.SCHEDULING_BY_LINE.communities[communityId] &&
        userPermissions.SCHEDULING_BY_LINE.communities[communityId].includes('read')
      );
    else return false;
  },
);
